<template>
  <div class="fc-notification-form fc-notification-form--stack">
    <NotificationConfigureHeader
      :title="copy.title"
      :subtitle="copy.subtitle"
      kind="trigger"
      :icon="icon"
    />
    <NotificationNameField
      :value="name"
      :auto-name="autoName"
      :is-custom="nameIsCustom"
      :error="nameError"
      @input="name = $event"
      @update:isCustom="nameIsCustom = $event"
      @reset="resetName"
    />
    <p class="fc-notification-form__hint">{{ nameHint }}</p>
    <NotificationEnableRow
      v-model="flag"
      :hint="copy.enableHint"
      :disabled="disabled"
    />
    <div class="fc-notification-meta">
      <span class="fc-notification-chip">
        <v-icon x-small>mdi-account-outline</v-icon>
        {{ copy.sentTo }}
      </span>
      <span class="fc-notification-chip fc-notification-chip--info">
        <v-icon x-small>mdi-close-octagon-outline</v-icon>
        {{ copy.trigger }}
      </span>
    </div>
    <div class="fc-notification-infobox">
      <v-icon small>mdi-information-outline</v-icon>
      <p>
        Each Preparer gets <b>one email per rejected task</b>, with the rejection remark and a link
        to the task. A bulk rejection of several tasks sends one email per task.
      </p>
    </div>
  </div>
</template>

<script>
import {
  NotificationConfigureHeader,
  NotificationEnableRow,
  NotificationNameField,
} from '../../../../components/Notifications';
import {
  NOTIFICATION_FEATURE_ICON,
  NOTIFICATION_FORM_COPY,
  NOTIFICATION_TYPE_KEYS,
} from '../../../../utils/constants';
import { buildNotificationName } from '../../../../utils/notificationNameUtils';
import notificationFormErrorMixin from './notificationFormErrorMixin';

export default {
  name: 'TaskRejectedForm',
  components: {
    NotificationConfigureHeader,
    NotificationEnableRow,
    NotificationNameField,
  },
  mixins: [notificationFormErrorMixin],
  props: {
    value: { type: Object, default: () => ({}) },
    locations: { type: Array, default: () => [] },
    serverErrors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      name: this.value.name || '',
      nameIsCustom: this.value.name_is_custom === true,
      flag: this.value.flag !== false,
      copy: NOTIFICATION_FORM_COPY.taskRejected,
      nameHint: NOTIFICATION_FORM_COPY.NAME_HINT_SIMPLE,
      icon: NOTIFICATION_FEATURE_ICON.taskRejected,
    };
  },
  computed: {
    autoName() {
      return buildNotificationName(NOTIFICATION_TYPE_KEYS.TASK_REJECTED, {}, []);
    },
  },
  methods: {
    resetName() {
      this.nameIsCustom = false;
      this.name = this.autoName;
    },
    toPayload() {
      return {
        featureDetails: {
          _id: this.value._id,
          feature: NOTIFICATION_TYPE_KEYS.TASK_REJECTED,
          flag: this.flag,
          name: this.nameIsCustom ? this.name : this.autoName,
          name_is_custom: this.nameIsCustom,
          meta: { roles: [], locations: [] },
        },
      };
    },
  },
};
</script>
